export default __webpack_public_path__ + "static/media/school-bag.dbc917ce.jpg";